module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "webdebtorlist",
    attrs: {
      "id": "debtorList"
    }
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverContacts",
      "subNavTitle": "Other Debtors LALA",
      "menuAccess": false
    }
  }), _vm._v(" "), _c('f7-searchbar', {
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#debtors-list",
      "placeholder": "Search in debtor list"
    },
    on: {
      "searchbar:search": _vm.onSearch
    }
  }), _vm._v(" "), _c('f7-list', {
    attrs: {
      "id": "debtors-list"
    }
  }, _vm._l((_vm.debtors), function(debtor, index) {
    return _c('li', {
      key: debtor.debtorBank,
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(debtor.debtorName))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_c('i', {
      staticClass: "f7-icons color-red",
      on: {
        "click": function($event) {
          return _vm.removeDebtor(index)
        }
      }
    }, [_vm._v("close_round_fill")])])])])
  }), 0)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45d9e2fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45d9e2fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/payments/CMDebtorList.vue
// module id = 1662
// module chunks = 2